// src/components/ComplaintForm/ComplaintForm.js

import React, { useState } from 'react';
import './ComplaintFormDemo.css';

const ComplaintFormDemo = () => {
  const [formData, setFormData] = useState({
    complaintDate: '',
    partDescription: '',
    partSerialNo: '',
    issueDescription: '',
    troubleshootingSteps: '',
    mediaUpload: null,
    whereDetected: '',
    rootCause: '',
    correctiveAction: '',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder for backend integration
  };

  return (
    <div className="form-container">
      <h2>Complaint Form</h2>
      <form onSubmit={handleSubmit}>
        {/* Complaint Date */}
        <div className="form-group">
          <label htmlFor="complaintDate">Complaint Date:</label>
          <input
            type="date"
            id="complaintDate"
            name="complaintDate"
            value={formData.complaintDate}
            onChange={handleChange}
            required
          />
        </div>

        {/* Part Description */}
        <div className="form-group">
          <label htmlFor="partDescription">Part Description:</label>
          <select
            id="partDescription"
            name="partDescription"
            value={formData.partDescription}
            onChange={handleChange}
            required
          >
            <option value="">Select a part</option>
            <option value="Part A">Part A</option>
            <option value="Part B">Part B</option>
            {/* Add more options as needed */}
          </select>
        </div>

        {/* Part Serial No. */}
        <div className="form-group">
          <label htmlFor="partSerialNo">Part Serial No.:</label>
          <input
            type="text"
            id="partSerialNo"
            name="partSerialNo"
            value={formData.partSerialNo}
            onChange={handleChange}
            required
          />
        </div>

        {/* Issue Description */}
        <div className="form-group">
          <label htmlFor="issueDescription">Issue Description:</label>
          <textarea
            id="issueDescription"
            name="issueDescription"
            value={formData.issueDescription}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        {/* Troubleshooting Steps */}
        <div className="form-group">
          <label htmlFor="troubleshootingSteps">Troubleshooting Steps:</label>
          <textarea
            id="troubleshootingSteps"
            name="troubleshootingSteps"
            value={formData.troubleshootingSteps}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        {/* Media Upload */}
        <div className="form-group">
          <label htmlFor="mediaUpload">Media Upload:</label>
          <input
            type="file"
            id="mediaUpload"
            name="mediaUpload"
            onChange={handleChange}
          />
        </div>

        {/* Where Detected */}
        <div className="form-group">
          <label htmlFor="whereDetected">Where Detected:</label>
          <select
            id="whereDetected"
            name="whereDetected"
            value={formData.whereDetected}
            onChange={handleChange}
            required
          >
            <option value="">Select an option</option>
            <option value="Production">Production</option>
            <option value="Testing">Testing</option>
            {/* Add more options as needed */}
          </select>
        </div>

        {/* Root Cause (View Only) */}
        <div className="form-group">
          <label htmlFor="rootCause">Root Cause:</label>
          <textarea
            id="rootCause"
            name="rootCause"
            value={formData.rootCause}
            readOnly
          ></textarea>
        </div>

        {/* Corrective Action (View Only) */}
        <div className="form-group">
          <label htmlFor="correctiveAction">Corrective Action:</label>
          <textarea
            id="correctiveAction"
            name="correctiveAction"
            value={formData.correctiveAction}
            readOnly
          ></textarea>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-orange">
          Submit
        </button>
      </form>
    </div>
  );
};

export default ComplaintFormDemo;
